import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import DropTemporaryPinPage from './DropTemporaryPinPage/DropTemporaryPinPage';
import DropPinSheet from './DropPinSheet/DropPinSheet';

const DropPinFeature: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <DropPinSheet />
        </AuthCheck>
      </Route>

      <Route path={`${path}/location`} exact>
        <DropTemporaryPinPage />
      </Route>
    </Switch>
  );
};

export default DropPinFeature;
